<div [class]="colorClass">
  @if (text) {
    <p>{{ text || '' }}</p>
  }
  <mat-spinner [diameter]="diameter || 64" [strokeWidth]="strokeWidth || 2"></mat-spinner>
</div>
